<template lang="html">
  <div class="batch-status">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleManageMailsort','titleManageMailsort') }}</h6>
          <div class="element-box">
            <div>
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-search2"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('manageMailsortSearch','manageMailsortSearch') }}</h5>
                        <div class="element-inner-desc">{{ t('descManageMailsortSearch','descManageMailsortSearch') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4">
                    <i id="mailsortToggle" v-b-toggle.mailsortBox class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                  </div>
                </div>
              </div>
              <b-collapse visible class="col-12 px-0" id="mailsortBox">
                <form v-on:submit.prevent="requestMailsortList">
                  <div class="col-lg-12 row">
                    <div class="col-lg-3">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-id" class="d-block text-center">{{t('searchLabelBatchNumber','searchLabelBatchNumber') }}</label>
                          <input id="batch-id" v-model="mailsortRequest.batch_id" class="form-control text-center" :placeholder="t('searchLabelBatchNumber','searchLabelBatchNumber')" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-ref" class="d-block text-center">{{t('searchLabelBatchRef','searchLabelBatchRef') }}</label>
                          <input id="batch-ref" v-model="mailsortRequest.batch_ref" class="form-control text-center" :placeholder="t('searchLabelBatchRef','searchLabelBatchRef')" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-ref" class="d-block text-center">{{t('searchLabelMailsortTrigger','searchLabelMailsortTrigger') }}</label>
                          <b-form-select id="mailsort_trigger" v-model="mailsortRequest.mailsortTrigger" class="form-control custom-select text-capitalize">
                            <option value="all" selected>{{ t('optionAll', 'optionAll') }}</option>
                            <option value="1" selected>{{ t('optionYes', 'optionYes') }}</option>
                            <option value="0" selected>{{ t('optionNo', 'optionNo') }}</option>
                          </b-form-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-after" class="d-block text-center">{{t('searchLabelBatchType','searchLabelBatchType') }}</label>
                          <b-form-select v-if="batchTypes" id="mailsort_types" v-model="mailsortRequest.batch_type" class="form-control custom-select text-capitalize">
                            <option value="all" selected>{{ t('optionAll', 'optionAll') }}</option>
                            <option v-for="type in batchTypes" class="text-capitalize" :value="type.id" selected>{{ t(type.name, type.name) }}</option>
                          </b-form-select>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-before" class="d-block text-center">{{ t('searchLabelBatchStatus','searchLabelBatchStatus') }}</label>
                            <b-form-select v-if="batchStatuses" id="mailsort_status" v-model="mailsortRequest.batch_status" class="form-control custom-select text-capitalize">
                              <option value="all" selected>{{ t('optionAll', 'optionAll') }}</option>
                              <option v-for="status in batchStatuses" class="text-capitalize" :value="status.status" selected>{{ t(status.status, status.status) }}</option>
                            </b-form-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-after" class="d-block text-center">{{t('searchLabelBatchAddedAfter','searchLabelBatchAddedAfter') }}</label>
                          <datePicker id="batch-after" v-model="mailsortRequest.added_after" class="form-control text-center" :config="datePickerAfterConfig" :placeholder="t('searchLabelBatchAddedAfter','searchLabelBatchAddedAfter')">
                          </datePicker>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-before" class="d-block text-center">{{ t('searchLabelBatchAddedBefore','searchLabelBatchAddedBefore') }}</label>
                          <datePicker id="batch-before" v-model="mailsortRequest.added_before" class="form-control text-center" :config="datePickerBeforeConfig" :placeholder="t('searchLabelBatchAddedBefore','searchLabelBatchAddedBefore')">
                          </datePicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 px-0 text-right">
                      <button class="btn btn-primary float-right ml-2" type="submit" >{{ t('searchButtonText','searchButtonText') }}</button>
                    </div>
                  </div>
                </form>
              </b-collapse>
            </div>
          </div>
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table width-control">
                <div v-if="mailsortRecords" class="table-records-info">
                  <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                  <p v-else>{{totalRows}} {{ t('entriesFoundRecordsLabel','entriesFoundRecordsLabel') }}</p>
                </div>
                <div>
                  <b-pagination v-if="mailsortRecords" v-model="currentPage" ref="paginationStartTop" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                  </b-pagination>
                </div>
              </div>
              <div class="col-12 px-0">
                <ResponseInfo v-if="getResponseInfo.responseName == 'manageMailsort'" class="mt-2"/>		
              </div>
              <div v-if="mailsortRecords" class="table-records-info mx-3">
                <button type="button" class="btn btn-primary" @click="sendTriggerFile()" :disabled="triggerBatches && Object.keys(triggerBatches).length < 1">{{ t('sendTriggerFileBtn', 'sendTriggerFileBtn') }}</button>
              </div>
              <div v-if="mailsortRecords" class="table-responsive auto-scroll">
                <b-table id="start-reports" striped hover bordered responsive class="mt-3" hide-footer :busy.sync="isBusy" :items="mailsortRecords" :fields="startFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                :total-rows="totalRows" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" :thead-class="'brand-color'">
                  <template v-slot:head(trigger)="data">
                    <span></span>
                  </template>
                  <template v-slot:head(id)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(reference)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(type_name)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(status)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(total_posted)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(added_on)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(approved_on)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(transfer_status)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(is_triggered)="data">
                    <span>{{ t(data.label, data.label) }}</span>
                  </template>
                  <template class="busy-row" v-slot:table-busy>
                    <div class="vld-parent spinner-row text-center">
                      <loading :active.sync="isBusy"
                      :can-cancel="false"
                      :color="'#047bf8'"
                      :loader="'dots'"
                      :is-full-page="false"></loading>
                    </div>
                  </template>
                  <template v-slot:empty="scope">
                    <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
                  </template>
                  <template v-slot:cell(trigger)="data">
                    <span v-if="data.item.transfer_status && data.item.transfer_status == 'Transferred'">
                      <b-form-checkbox :value="1" :unchecked-value="0" v-model="triggerBatches[data.item.id]" />
                    </span>
                    <span v-else>
                    </span>
                  </template>
                  <template v-slot:cell(id)="row">
                    <span v-if="row.item.test_mode" class="text-danger">{{ row.item.id }}</span>
                    <span v-else>{{ row.item.id }}</span>
                  </template>
                  <template v-slot:cell(reference)="data">
                    <span>
                      <router-link :to="{name: 'documents', props: { id: data.item.id}}" :title="`${t('uploadedOn', 'uploadedOn')} ${data.item.added_on}`">{{ data.item.reference }}</router-link>
                    </span>
                  </template>
                  <template v-slot:cell(type_name)="data">
                    <span class="text-capitalize">{{ data.item.type_name }} </span>
                  </template>
                  <template v-slot:cell(status)="data">
                    <span class="text-capitalize">{{ data.item.status }}</span>
                  </template>
                  <template v-slot:cell(total_posted)="data">
                    <span>{{ data.item.total_posted }} </span>
                  </template>
                  <template v-slot:cell(added_on)="data">
                    <span>{{ data.item.added_on }} </span>
                  </template>
                  <template v-slot:cell(approved_on)="data">
                    <span>{{ data.item.approved_on }} </span>
                  </template>
                  <template v-slot:cell(transfer_status)="data">
                    <span>{{ t('mailsortStatus' + data.item.transfer_status, 'mailsortStatus' + data.item.transfer_status) }} </span>
                  </template>
                  <template v-slot:cell(is_triggered)="data">
                    <span v-if="data.item.mail_sort_trigger">{{ t('yesText', 'yesText') }}</span>
                    <span v-else>{{ t('noText', 'noText') }}</span>
                  </template>
                </b-table>
              </div>
              <div class="controls-below-table pt-4 width-control">
                <div v-if="mailsortRecords" class="table-records-info">
                  <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                  <p v-else class="mb-0">{{totalRows}} {{ t('entriesFoundRecordsLabel','entriesFoundRecordsLabel') }}</p>
                </div>
                <div>
                  <b-pagination v-if="mailsortRecords" v-model="currentPage" ref="paginationStartBottom" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
    <ModalConfirmTriggerFile :batches="this.triggerBatches"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import Loading from 'vue-loading-overlay'
import ModalConfirmTriggerFile from '@/components/Manage_Mailsort/ModalConfirmTriggerFile.vue'
import ResponseInfo from '@/components/ResponseInfo.vue'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
name: 'ManageMailsort',
//these functions and values are inheritable from this component
provide() {
  return {
      batchRefTrim: this.batchRefTrim,
      datePickerFormat: this.datePickerFormat
  }
},
data() {
  return {
    mailsortRecords: null,
    triggerBatches: {},
    triggerMsg: null,
    startFields: [
      {key: 'trigger', label:'', sortable: false, thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'id', label:'tableHeadBatchId', sortable: false, thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'reference', label: 'tableHeadBatchReference', thClass: 'standard-th-width-xl', tdClass: 'standard-cell-width-xl'},
      {key: 'type_name', label: 'tableHeadBatchType', sortable: true, thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'status', label: 'tableHeadBatchStatus', sortable: true, thClass: ['showhand'], tdClass: 'text-center'},
      {key: 'total_posted', label:'tableHeadTotalPostedMailsort', tdClass: 'cell-small', sortable: true, thClass: ['showhand']},
      {key: 'added_on', label: 'tableHeadAddedOn', sortable: false, thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'approved_on', label: 'tableHeadApprovedOn', sortable: false, thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'transfer_status', label: 'tableHeadTransferStatus', sortable: false,  thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'is_triggered', label:'tableHeadIsTriggered', sortable: false, thClass: ['showhand'], tdClass: ['standard-cell-width-small', 'text-center']}
    ],
    datePickerAfterConfig: {
      icons: {
        time: 'os-icon os-icon-calendar-time',
        date: 'os-icon os-icon-basic-2-259-calendar',
        up: 'os-icon os-icon-chevron-up',
        down: 'os-icon os-icon-chevron-down',
        previous: 'os-icon os-icon-chevron-left',
        next: 'os-icon os-icon-chevron-right',
        clear: 'os-icon os-icon-trash',
        close: 'os-icon os-icon-cancel-circle'
      },
      showClear: true
    },
    datePickerBeforeConfig: {
      icons: {
        time: 'os-icon os-icon-calendar-time',
        date: 'os-icon os-icon-basic-2-259-calendar',
        up: 'os-icon os-icon-chevron-up',
        down: 'os-icon os-icon-chevron-down',
        previous: 'os-icon os-icon-chevron-left',
        next: 'os-icon os-icon-chevron-right',
        clear: 'os-icon os-icon-trash',
        close: 'os-icon os-icon-cancel-circle'
      },
      minDate: moment('1979-01-01', this.datePickerFormat),
      showClear: true
    },
    currentPage: 1,
    perPage: 20,
    sortBy: null,
    sortDesc: false,
    pageOptions: [10, 20, 50, 100],
    filter: null,
    isBusy: false,
    rowEmpty: false,
    totalRows: null,
    filteredRows: '',
    overlayBackgroundDisplay: false,
    mailsortRequest: {
      page: this.$route.query.page,
      per_page: this.$route.query.per_page,
      batch_ref: this.$route.query.batch_ref ? this.$route.query.batch_ref : null,
      batch_number: this.$route.query.batch_number ? this.$route.query.batch_number : null,
      batch_type: this.$route.query.batch_type ? this.$route.query.batch_type : null,
      batch_status: this.$route.query.batch_status ? this.$route.query.batch_status : null,
      uploaded_after: this.$route.query.uploaded_after ? this.$route.query.uploaded_after : null,
      uploaded_before: this.$route.query.uploaded_before ? this.$route.query.uploaded_before : null,
      mailsortTrigger: this.$route.query.mailsortTrigger ? this.$route.query.mailsortTrigger : null
    }
  }
},
computed: {
  ...mapGetters(['allTemplateDetails', 'getUserDetails', 'getBatchTypesForStatus', 'getUserLevel', 'getResponseInfo']),
  batchTypes: {
    get() {
      return this.$store.getters.getBatchTypesForStatus
    },
    set(batchTypes) {
      this.$store.commit('setBatchTypesForStatus', batchTypes)
    }
  },
  batchStatus: {
    get() {
      return this.$store.getters.getBatchStatus
    }
  },
  batchStatuses: {
    get() {
      return this.$store.getters.getBatchStatuses
    },
    set(batchStatuses) {
      this.$store.commit('setBatchStatuses', batchStatuses)
    }
  },
  datePickerFormat: {
    get() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
        return dateformat
      } else {
        return "DD-MM-YYYY"
      }
    }
  },
  batchRefTrim: {
    get() {
      return this.$store.getters.allTemplateDetails.batchRefTrim
    }
  },
  date_from() {
    return this.mailsortRequest.upload_after
  }
},
watch: {
  date_from(date) {
    if(date){
      let dateFrom = moment(date, this.datePickerFormat)
      this.datePickerBeforeConfig.minDate = dateFrom
    }else{
      this.datePickerBeforeConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
    }
  },
  perPage() {
    if(this.mailsortRequest.per_page !== this.perPage) {
      this.mailsortRequest.per_page = this.perPage
      this.requestMailsortList()
    }
  }
},
methods: {
  onFiltered(filteredItems) {
    this.filteredRows = filteredItems.length
    this.currentPage = 1
  },
  manualPagination(newPage) {
    let page = parseInt(newPage)
    if(this.mailsortRequest.page !== page) {
      this.mailsortRequest.page = page
      this.requestMailsortList()
    }
  },
  requestMailsortList() {
    this.isBusy = true
    Object.keys(this.mailsortRequest).forEach((key) => ((this.mailsortRequest[key] == '') || (this.mailsortRequest[key] == null)) && (this.mailsortRequest[key] = undefined))
    this.$router.push({ query: { ...this.$route.query, page: this.mailsortRequest.page , per_page: this.mailsortRequest.per_page, ...this.mailsortRequest } })
    
    this.$store.dispatch('mailsortStore/getMailsortRecords', {
      page: this.mailsortRequest.page,
      per_page: this.mailsortRequest.per_page,
      batch_id: this.mailsortRequest.batch_id ? this.mailsortRequest.batch_id : null,
      batch_ref: this.mailsortRequest.batch_ref ? this.mailsortRequest.batch_ref : null,
      batch_type: this.mailsortRequest.batch_type ? this.mailsortRequest.batch_type : null,
      batch_status: this.mailsortRequest.batch_status ? this.mailsortRequest.batch_status : null,
      uploaded_after : this.mailsortRequest.upload_after ? this.mailsortRequest.upload_after : null,
      uploaded_before : this.mailsortRequest.upload_before ? this.mailsortRequest.upload_before : null,
      approved_after: this.mailsortRequest.added_after ? this.mailsortRequest.added_after : null,
      approved_before: this.mailsortRequest.added_before ? this.mailsortRequest.added_before : null,
      mailsortTrigger: this.mailsortRequest.mailsortTrigger ? this.mailsortRequest.mailsortTrigger : null,
      userLevel: this.getUserLevel
    })
    .then(response => {
      this.isBusy = false
      this.totalRows = response.mailsortCount
      this.mailsortRecords = response.mailsortData
      
      //if the response is empty and not because of an incorrect pagination request
      if((!this.totalRows) || (this.totalRows.length == 0)) {
        this.rowEmpty = true
      }

      //setting the table variables
      this.currentPage = parseInt(this.mailsortRequest.page)
      this.perPage = parseInt(this.mailsortRequest.per_page)

    }, this)
  },
  sendTriggerFile() {
    this.triggerMsg = ''
    if(this.triggerBatches && Object.keys(this.triggerBatches).length > 0) {
      this.overlayBackgroundDisplay = true
      this.$root.$emit('bv::show::modal', 'ModalConfirmTriggerFile')
    }
  }
},
created() {
  this.batchTypes = this.$store.dispatch('getBatchTypesForStatus')
  this.batchStatuses = this.$store.dispatch('getBatchStatuses')

  // initializing the datepicker's format
  this.datePickerAfterConfig.format = this.datePickerFormat
  this.datePickerBeforeConfig.format = this.datePickerFormat

  let todaysDate = moment(new Date(), this.datePickerFormat)
  this.datePickerAfterConfig.maxDate = todaysDate
  this.datePickerBeforeConfig.maxDate = todaysDate

  if(Object.keys(this.$route.query).length) {
    this.mailsortRequest = Object.assign({}, this.$route.query)

    if(this.$route.query.page) {
      this.mailsortRequest.page = parseInt(this.$route.query.page)
    } else {
      this.mailsortRequest.page = 1
    }

    if(this.$route.query.per_page) {
      this.mailsortRequest.per_page = parseInt(this.$route.query.per_page)
    } else {
      this.mailsortRequest.per_page = 20
    }

    this.requestMailsortList()
  } else {
    if((this.mailsortRequest.page == undefined) || (this.mailsortRequest.page == null) || (this.mailsortRequest.page == '')){
      this.mailsortRequest.page = 1
    }
    if((this.mailsortRequest.per_page == undefined) || (this.mailsortRequest.per_page == null) || (this.mailsortRequest.per_page == '')){
      this.mailsortRequest.per_page = 20
    }
    this.requestMailsortList()
  }
},
beforeDestroy() {
  this.mailsortRecords = []
},
filters: {
  trimBatchReference: function(reference, batchRefTrim) {
    if (reference && reference !== '') {
      return reference.slice(0, batchRefTrim)
    }
  },
  humanReadable: function(date) {
    return moment(date).format('MMMM Do YYYY, h:mm:ss a')
  },
  clientDateFormat: function(date, datePickerFormat) {
    return moment(date).format(datePickerFormat + ' h:mm:ss')
  }
},
components: {
  Loading,
  datePicker,
  ModalConfirmTriggerFile,
  ResponseInfo
}
}
</script>

<style lang="css" scoped>
/*-----SEARCH BAR-----*/
.text-netsend-blue {
  color: #047bf8;
}
.batch-search-border {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}
#mailsortToggle {
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#mailsortToggle.collapsed {
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.showhand {
  cursor: pointer;
}

#dropdown-status >>> ul {
  box-shadow: 0 0 1px rgba(15, 24, 33, 0.5),
  0 25px 65px rgba(15, 24, 33, 0.29);
}
.dropdown-withform {
  min-width: 250px;
}

.table-responsive {
  max-width: 90vw;
  margin: 0 auto;
}

.width-control {
   max-width: 90vw !important;
   margin: 0 auto;
}

.table-responsive >>> .cell-small {
  min-width: 25px;
  text-align: center;
  white-space: nowrap;
}

/*-----Placeholder text centering-----*/
::-webkit-input-placeholder {
  text-align: center;
}
:-moz-placeholder { /* Firefox 18- */
  text-align: center;
}
::-moz-placeholder {  /* Firefox 19+ */
  text-align: center;
}
:-ms-input-placeholder {
  text-align: center;
}

.text-capitalize {
  text-transform: capitalize;
}

.auto-scroll {
  overflow-x: auto;
}
</style>
